module.exports = __webpack_public_path__ + "static/media/link.ffbfb97d.svg";